<!-- modal ver contacto -->
<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="760" scrollable>
      <v-card class="vc-card">
        <v-card-title class="vc-hero py-3">
          <div class="d-flex align-center" style="gap: 12px;">
            <v-avatar color="white" size="40" class="elevation-1">
              <v-icon color="deep-orange darken-3">mdi-account</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 white--text">{{ contacto.nombres }} {{ contacto.apellidos }}</div>
              <div class="text-body-2 white--text">Detalle del contacto</div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="pt-4 px-12">
          <v-row dense>
            <v-col cols="12" sm="6">
              <div class="text-caption text--secondary"> <b>Teléfono</b> </div>
              <div class="text-body-2">{{ contacto.telefono || '—' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="text-caption text--secondary"><b>Correo</b></div>
              <div class="text-body-2">{{ contacto.correo || '—' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="text-caption text--secondary"><b>Origen</b></div>
              <div class="text-body-2">{{ contacto.origen || '—' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="text-caption text--secondary"><b>Área de interés</b></div>
              <div class="text-body-2">{{ contacto.area_interes_name || '—' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="text-caption text--secondary"><b>Profesión</b></div>
              <div class="text-body-2">{{ contacto.profesion_name || '—' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="text-caption text--secondary"><b>Estado</b></div>
              <v-chip x-small :color="contacto.estado === 'activo' ? 'green' : 'grey'" dark>
                {{ contacto.estado }}
              </v-chip>
            </v-col>
            <v-col cols="12">
              <div class="text-caption text--secondary"> <b>Programa de interés</b> </div>
              <div class="text-body-2">{{ contacto.programa_interes_name || '—' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="text-caption text--secondary"><b>Asesor</b></div>
              <div class="text-body-2">{{ contacto.asesor_name || '—' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="text-caption text--secondary"><b>Fecha de registro</b></div>
              <div class="text-body-2">{{ contacto.fecha_registro ? contacto.fecha_registro.slice(0, 10) : '—' }}</div>
            </v-col>

            <v-col cols="12" class="mt-2">
              <div class="text-caption text--secondary"> <b>Observaciones / comentarios</b> </div>
              <div class="text-body-2">{{ contacto.observaciones }}</div>
            </v-col>
          </v-row>

          <v-divider />
          <!-- <v-btn color="blue" outlined class="black--text mb-3" small @click="opencursados()">
            <v-icon left small>mdi-eye</v-icon>
            ver programas cursados
          </v-btn> -->

          <v-divider />
          <timelineProgreso ref="reftimelineProgreso"/>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> 
  </div>
</template>

<script>
import timelineProgreso from './timeline-progreso.vue';

export default {
  components:{ timelineProgreso },
  data() {
    return {
      dialog: false,
      contacto: {},
    };
  },
  methods: {
    openmodal(contacto) {
      this.contacto = contacto;
      this.dialog = true;

      this.$nextTick(() => {
        this.$refs.reftimelineProgreso.iniciar(-1, false); 
      }); 
    },
  },
};
</script>

<style scoped>
.vc-card {
  border-radius: 14px;
  overflow: hidden;
}
.vc-hero {
  background: linear-gradient(120deg, #ff6a00 0%, #ff3d00 45%, #ffb300 100%);
}
</style>
